var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 3.99984H15.3335V10.5332H16.6668V3.99984C16.6668 3.64622 16.5264 3.30708 16.2763 3.05703C16.0263 2.80698 15.6871 2.6665 15.3335 2.6665H4.66683C4.31321 2.6665 3.97407 2.80698 3.72402 3.05703C3.47397 3.30708 3.3335 3.64622 3.3335 3.99984V19.9998C3.3335 20.3535 3.47397 20.6926 3.72402 20.9426C3.97407 21.1927 4.31321 21.3332 4.66683 21.3332H15.3335C15.6871 21.3332 16.0263 21.1927 16.2763 20.9426C16.5264 20.6926 16.6668 20.3535 16.6668 19.9998H4.66683V3.99984Z",
    fill: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7734 11.5202C18.6459 11.411 18.4818 11.3539 18.314 11.3604C18.1463 11.3668 17.9871 11.4364 17.8684 11.5551C17.7496 11.6739 17.6801 11.833 17.6736 12.0008C17.6671 12.1686 17.7242 12.3326 17.8334 12.4602L20.0868 14.6668H10.4201C10.2433 14.6668 10.0737 14.7371 9.94868 14.8621C9.82366 14.9871 9.75342 15.1567 9.75342 15.3335C9.75342 15.5103 9.82366 15.6799 9.94868 15.8049C10.0737 15.9299 10.2433 16.0002 10.4201 16.0002H20.0868L17.8334 18.3068C17.7636 18.3666 17.707 18.4401 17.6669 18.5229C17.6269 18.6056 17.6044 18.6957 17.6009 18.7875C17.5973 18.8793 17.6128 18.9708 17.6463 19.0564C17.6798 19.1419 17.7307 19.2196 17.7957 19.2846C17.8606 19.3496 17.9383 19.4004 18.0239 19.4339C18.1094 19.4674 18.201 19.4829 18.2928 19.4794C18.3846 19.4758 18.4747 19.4533 18.5574 19.4133C18.6401 19.3733 18.7137 19.3166 18.7734 19.2468L22.6668 15.3802L18.7734 11.5202Z",
    fill: "#FF5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLogo);
export default __webpack_public_path__ + "static/media/logoutLogo.30738e0bec7706ba5d747e7cc49e7fa4.svg";
export { ForwardRef as ReactComponent };